import o from "react";
import n from "prop-types";
import { T as r } from "./index-Dd-4N6BE.es.js";
import './DateLabel.css';const m = "DateLabel-module__label___5JWr-", s = {
  label: m
};
function a(e) {
  const t = new Date(e.year, (e.month || 1) - 1, 2), l = t.toISOString();
  return /* @__PURE__ */ o.createElement(
    "time",
    {
      className: s.label,
      dateTime: l.substring(0, e.month ? 7 : 4)
    },
    /* @__PURE__ */ o.createElement(r.Body, { responsive: !0 }, e.month ? `${t.toLocaleString(void 0, {
      month: "long"
    })} ${t.getFullYear()}` : `${t.getFullYear()}`)
  );
}
a.propTypes = {
  month: n.number,
  year: n.number.isRequired
};
a.defaultProps = {
  month: null
};
export {
  a as D
};
